import React, {Fragment} from "react";
import ModalDocumentoArchivio from "./ModalDocumentoArchivio";
import ContainerFotoArchivio from "../ContainerFotoArchivio";
import {useHistory} from "react-router-dom";
import {getDataFormattata} from "../../../../utility/common";

export default function ContenutoArchivioDocumentiView({
                                                  documenti,
                                                  isRuoloAd,
                                                  openModalAddDocumento,
                                                  closeModalAddDocumento,
                                                  addDocumentoOk,
                                                  tema,
                                                  sottotema = null,
                                                  titolo,
                                                  showModalAddDoc,
                                              }) {

    const history = useHistory();

    return (
        <Fragment>
            <ModalDocumentoArchivio
                tema={tema}
                titolo={titolo}
                sottotema={sottotema}
                show={showModalAddDoc}
                handleClose={closeModalAddDocumento}
                submitOk={addDocumentoOk}
                labelAdd={sottotema ? `Aggiungi ${sottotema}` : tema.label_add}
            />
            <div className="row g-3">
                {
                    !isRuoloAd && documenti.length === 0 &&
                    <h5>Nessun documento caricato</h5>
                }
                {
                    isRuoloAd &&
                    <div className={"col-md-3"}>
                        <div
                            className={"ns-container-foto-upl ns-cursor-pointer ns-hover-shadow"}
                            onClick={openModalAddDocumento}
                        >
                            <div className={"ns-container-foto-archivio-label text-center"}>
                                <span aria-hidden="true">
                                    <div style={{
                                        height: "66px"
                                    }}>
                                        <h6>{sottotema ? `Aggiungi ${sottotema}` : tema.label_add}</h6>
                                    </div>
                                    <div className={"ns-foto"}>
                                        <div className={"ns-foto-img"}>
                                            <i className="fas fa-plus-circle" style={{fontSize: "6rem"}}></i>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {
                    documenti.map((f, idx) =>
                        <div className={"col-md-3"} key={idx}>
                            <ContainerFotoArchivio
                                idDocumento={f.id_archivio_documento}
                                tema={tema}
                                titolo={f.titolo}
                                sottotitolo={`${f.anno_doc || (f.data_doc ? getDataFormattata(f.data_doc) : '-')} ${parseInt(f.anno_circa) === 1 ? 'ca.' : ''}`}
                                nome={f.nome_file}
                                endpointContent={process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${f.id_archivio_documento}?anteprima=1`}
                                handleOnClick={() => {
                                    history.push(`/documento-archivio/${f.id_archivio_documento}`);
                                }}
                            />
                        </div>
                    )
                }
            </div>
        </Fragment>
    );
}